export const visibilityName =
    [
        '스토어 명',
        '상품 명',
        '상품 가격',
        '메인 키워드',
        '상품 이미지',
        '네이버 쇼핑 상품 순위',
        '클립 보드 버튼',
        '미션하러가기 버튼',
    ]

export const PlaceVisibilityName =
    [
            '클립 보드 버튼',
            '미션하러가기 버튼',
            '주소',
            '이름',
            '현재 순위',
            '1위 키워드',
            '메인 키워드',
            '이미지',
    ]